import { ApolloClient, InMemoryCache } from '@apollo/client';
// import { RetryLink } from '@apollo/client/link/retry';
import { AxiosLink } from './axiosLink';
import { authInterceptor } from '../apiClient/httpClient';

// const GRAPQL_WS_URL = import.meta.env.VITE_API_GQL_WSS_URL;

const axiosLink = new AxiosLink(authInterceptor.getInstance());

// const retryLink = new RetryLink({
//   delay: {
//     initial: 300,
//     max: Infinity,
//     jitter: true,
//   },
//   attempts: {
//     max: 20,
//     retryIf: (error) => !!error,
//   },
// });

// const wsLink = new WebSocketLink({
//   uri: GRAPQL_WS_URL,
//   options: {
//     reconnect: true,
//     connectionParams: () => {
//       const { access: accessToken } = AuthInterceptor.getTokens();

//       if (accessToken) {
//         return {
//           Authorization: `Bearer ${accessToken}`,
//         };
//       }
//       return {};
//     },
//   },
// });

// const splitLink = split(
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
//   },
//   wsLink,
//   retryLink.concat(axiosLink)
// );

// Create the Apollo Client
const client = new ApolloClient({
  link: axiosLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
  },
});

export default client;
